/*
Use: 
import localDataFunctions from '@/localDataFunctions';
mixins: [localDataFunctions],
*/

export default {
  name: 'LocalDataFunctions',
  data: function () {
    return {};
  },
  methods: {
    getFromLocal(location) {
      let item = this.$localStorage.get(location);
      if (!item) return null;
      if (this.isJson(item)) return JSON.parse(item);
      else return item;
    },
    saveToLocal(location, item, parseJson = true) {
      let saveItem;
      if (parseJson) saveItem = JSON.stringify(item);
      else saveItem = item;

      this.$localStorage.set(location, saveItem);
      return item;
    },
    removeFromLocal(location) {
      this.$localStorage.remove(location);
    },
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
  }
};
